import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';
import { DcIcons } from 'src/app/ui/app-dc.icons';

export enum TimelineAction {
	Delete = 'delete',
}

export interface ITimelineActionModalData {
	timelineId: number | Array<number>;
	element: string;
	action: TimelineAction;
}

@Component({
	selector: 'app-timeline-action-popup',
	templateUrl: './timeline-action-popup.component.html',
	styleUrls: ['./timeline-action-popup.component.scss'],
})
export class TimelineActionPopupComponent<T extends ITimelineActionModalData>
	extends DcBaseComponent
	implements OnInit
{
	public vo$!: Observable<{
		element: string;
		timelineId: number | Array<number>;
		isMultipleElement: boolean;
		action: TimelineAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly TimelineAction = TimelineAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'timeline-action';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.timelineId) &&
				this.modalData.element === '',
			timelineId: this.modalData.timelineId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
